import { getDatabase, ref, remove, update } from 'firebase/database'

export const resetAccountType = async (userUid: string) => {
    return remove(ref(getDatabase(), `users/${userUid}/accountType`))
}

export const updateUserDetails = async (
    userId: string,
    data: {
        firstName?: string
        lastName?: string
        firstNameActual?: string | null
        contact?: string
        email?: string
    }
) => {
    const { firstName, lastName, firstNameActual, contact, email } = data
    // Update users node
    const userNode = ref(getDatabase(), `users/${userId}`)
    return update(userNode, {
        ...(firstName !== undefined ? { firstName } : null),
        ...(lastName !== undefined ? { lastName } : null),
        ...(firstNameActual !== undefined ? { firstNameActual } : null),
        ...(contact !== undefined ? { contact } : null),
        ...(email !== undefined ? { email } : null),
    })
}
